import LeftGroupList from "@/components/LeftGroupList";
import api from "@/api";
export default {
  name: "Unfolding3DSelector",
  components: {
    LeftGroupList
  },
  data() {
    return {
      groups: [],
      groupId: null,
      questions: []
    };
  },
  methods: {
    confirm(qid) {
      this.$emit('confirm', qid);
    },
    onChoose(gid) {
      this.groupId = gid;
      this.fetchList();
    },
    fetchList() {
      api.getUnfolding3DQuestionByGroupId(this.groupId).then(ret => {
        this.questions = ret.list;
      });
    },
    init() {
      api.getUnfolding3DQuestionGroups().then(list => {
        this.groups = list;
        this.groupId = list[0].value;
        this.fetchList();
      });
    }
  },
  mounted() {
    this.init();
  }
};